const officeAppsSrc = 'https://view.officeapps.live.com/op/embed.aspx?src=';

const iframeSources = {
    doc: officeAppsSrc,
    docx: officeAppsSrc,
    xls: officeAppsSrc,
    xlsx: officeAppsSrc,
    ppt: officeAppsSrc,
    pptx: officeAppsSrc,
    odt: officeAppsSrc,
    dwg: '//sharecad.org/cadframe/load?url=',
    pdf: '',
};

export const getIframeSrc = (extension: string) => {
    const lowerCaseExtension = extension.toLowerCase();
    return iframeSources.hasOwnProperty(lowerCaseExtension)
        ? iframeSources[lowerCaseExtension as keyof typeof iframeSources]
        : null;
};
